import React, { useContext } from 'react';
import { AppContext } from "../../Provider/Provider";

import './MedidorComponent.css';

// Ir sumando los kWh mediante se clickee en el botón confirmar
const Medidor = () => {

  const [valoresConsumoState, setValoresConsumoState] = useContext(AppContext);

  // Cálculo para la equivalencia: (grados * valor recibido)/tope;

  var totalkWhBim = valoresConsumoState.TotalkWhBim;

  /**
   *  Los topes son por colores porque la aguja se comporta de manera distinta
   *  en los distintos rangos
   */
  var greenTop = 600;
  var yelowTop = 866;
  var orangeTop = 1132;
  var tangerineTop = 1400;
  var redTop = 2000;  

  // Valores en grados
  var base = 0;
  var green = 35;
  var yelow = 71;
  var orange = 110;
  var tangerine = 146;
  var red = 180;
  
  var value = 0;

  if (totalkWhBim > base && totalkWhBim <= greenTop)
    value = (green * totalkWhBim) / greenTop;
  else if (totalkWhBim > greenTop && totalkWhBim <= yelowTop)
    value = (yelow * totalkWhBim) / yelowTop;
  else if (totalkWhBim > yelowTop && totalkWhBim <= orangeTop)
    value = (orange * totalkWhBim) / orangeTop;
  else if (totalkWhBim > orangeTop && totalkWhBim <= tangerineTop)
    value = (tangerine * totalkWhBim) / tangerineTop;
  else if (totalkWhBim > tangerineTop && totalkWhBim <= redTop)
    value = (red * totalkWhBim) / redTop;
  else if (totalkWhBim > redTop)
    value = red;


  // Mueve la aguja
  var needle = {
    transform: 'rotate('+value+'deg)',
    transition: '2s',
  };

  
  return (
    <div className={"gauge-wrapper"}>
      <div className={"gauge four rischio3"}>
        <div className={"slice-colors"}>
          <div className={"trapecio1"}></div>
          <div className={"trapecio2"}></div>
          <div className={"trapecio3"}></div>
          <div className={"trapecio4"}></div>
          <div className={"trapecio5"}></div>
        </div>
        <div className={"needle"} style={needle}></div>
        <div className="gauge-center">
          <div className="label">{totalkWhBim} kWh</div>
        </div>
      </div>
    </div>
  );
}

export default Medidor
